import { Row, Col } from "reactstrap"

import HtmlContent from "@components/common/HtmlContent"
import LinkButton from "@components/common/LinkButton"
import { withDynamicNamespaces } from "@components/hoc/withDynamicNamespaces"
import { MaintenanceMode } from "@modules/maintenance-mode"
import { NamespaceShortcut, useDynamicTranslation } from "@services/i18n/i18n"

const usedNamespaces: NamespaceShortcut[] = ["maintenance"]

/**
 * If the frontend is configured with a "maintenance mode bypass key",
 * this component shows a info/warning text for users.
 * 
 * See modules/maintenance-mode/readme.md
 */
const MaintenanceModeWarning: React.FC = () => {
  const t = useDynamicTranslation()

  // Refresh the validity duration of the bypass key when a user in bypass mode
  // requests a page where this component is included.
  const maintenanceBypassKey = MaintenanceMode.touchBypassKey()

  // TODO should this be placed to the MaintenanceMode module? But "row/col" specifics and i18n make it hard.
  return maintenanceBypassKey && <Row>
    <Col className="d-flex justify-content-center">
      <p className="text-warning">
        <HtmlContent content={t("maintenance", "warning")} />
        {" "}
        <LinkButton
          onClick={() => MaintenanceMode.removeBypassKey()}
          title={t("maintenance", "disableLinkText")}
        />
      </p>
    </Col>
  </Row>
}

export default withDynamicNamespaces(MaintenanceModeWarning, usedNamespaces)